// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"Container-749f1da0226c57bc","container-full-width-mobile":"Container-13bc8c122437f940"};